// firebase.js
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCMT7ttncPjORblgiyQW_ExRrl06OcuHAk",
    authDomain: "mdms-afe66.firebaseapp.com",
    projectId: "mdms-afe66",
    storageBucket: "mdms-afe66.appspot.com",
    messagingSenderId: "294085546408",
    appId: "1:294085546408:web:4e980ba40b8b1bc81f8d9d",
    measurementId: "G-PS1KDS1E8M"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

export { storage };

